module.exports = __webpack_public_path__ + "img/IcnMbMenu.86b35d39.png";